import { Tooltip } from 'react-tippy';

const SocialItem = ({ icon }) => (
  <div className="social-item">
    <div className="icon-circle-border">
      <div className="icon-circle">
        <span className={`tt-icon ${icon}`} />
      </div>
    </div>
  </div>
)

export default props => (  
  <Tooltip title={props.tooltip} theme="light">
    {props.link
      ? <a href={props.link} onClick={props.onClick}><SocialItem {...props} /></a>
      : <span onClick={props.onClick}><SocialItem {...props} /></span>
    }
  </Tooltip>
)
